import { MysteryBetSchema } from '@/views/races/components/MysteryBet/styles/MysteryBet.styles';
import mysteryLogo from '@/assets/questbet/images/mb-logo.png';

export const mysteryBetStyles: MysteryBetSchema = {
  flexWrapperOdds: {
    gap: 2,
    alignItems: 'center',
  },
  flexWrapperLogoOdds: {
    gap: 3,
  },
  buttonOdds: { variant: 'solid', px: '2' },
  imageLogo: {
    w: ['200px', '250px'],
    src: mysteryLogo,
  },
  iconMystery: {},
  buttonMysteryLabel: {
    variant: 'unstyled',
    color: 'white',
    gap: '2',
    bg: 'blackAlpha.400',
    borderRadius: 'md',
    p: '2',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 'sm',
    fontWeight: 'bold',
  },
  flexWrapperMysteryRolloverView: {
    w: 'fit-content',
    bg: 'blackAlpha.400',
    borderRadius: 'md',
    boxShadow: 'sm',
    px: '3',
    color: 'white',
    overflow: 'hidden',
    mx: 'auto',
    fontSize: 'xs',
  },
  flexWrapperMysteryPlacedBetView: {},
  flexWrapperMysteryBetSelectionView: {
    alignItems: 'center',
    justifyContent: 'center',
    gap: '2',
    my: '2',
    bg: 'alpha.100',
    borderRadius: 'md',
    boxShadow: 'sm',
    p: '2',
    mx: '2',
  },
  flexWrapperMysteryBetReviewView: {
    alignItems: 'center',
    justifyContent: 'center',
    flexDir: 'column',
    w: 'auto',
    gap: '2',
    bg: 'alpha.100',
    borderRadius: 'md',
    p: '2',
    my: '2',
    transition: '.3s ease-in-out',
    boxShadow: 'md',
    mx: '4',
  },
  flexWrapperMysteryErrorView: {
    alignItems: 'center',
    justifyContent: 'center',
    flexDir: 'row',
    w: 'full',
    gap: '2',
    my: '2',
    bg: 'blackAlpha.400',
    borderRadius: 'md',
    p: '2',
    transition: '.3s ease-in-out',
    boxShadow: 'md',
  },
  flexWrapperMysteryTooltipIcon: {
    alignItems: 'center',
    justifyContent: 'center',
    bgGradient: 'linear-gradient(to-b, #67C1D5, #126172)',
    borderRadius: 'md',
    boxSize: '8',
    p: '2',
    color: 'white',
    cursor: 'pointer',
  },
  imageMysteryBet: {
    w: '5',
    color: 'red',
    transform: 'rotate(180deg)',
    cursor: 'pointer',
    mr: '4',
  },
  flexRaceInfo: {
    textTransform: 'uppercase',
    fontSize: 'xs',
    color: 'white',
    fontWeight: 'bold',
  },
  textPriceInfo: {
    textTransform: 'uppercase',
    fontSize: 'xs',
    color: 'alpha.800',
    fontWeight: 'bold',
  },
  textRollover: {
    textTransform: 'uppercase',
    fontSize: 'xs',
    color: 'alpha.800',
    fontWeight: 'bold',
  },
  textError: {
    color: 'white',
    textTransform: 'uppercase',
    fontWeight: 'bold',
    fontSize: 'xs',
  },
  iconBack: {
    boxSize: '10',
    color: 'beta.500',
  },
  iconRace: { color: 'alpha.800' },
  textSpanWhite: {
    color: 'white',
  },
  buttonGroupAddToBetslip: {
    mr: '2',
    alignItems: 'center',
  },
  buttonAddToBetslip: {
    fontFamily: 'Roboto',
    fontWeight: 'extrabold',
    bgGradient: 'linear-gradient(to-b, #67C1D5, #126172)',
    h: '8',
  },
  flexWrapperMysteryLabelView: {
    fontFamily: 'Roboto',
    fontWeight: 'extrabold',
  },
  buttonRollOver: {
    variant: 'primary',
    h: '8',
  },
};
